<div class="conversation-list">
  <div class="conversation-list-title">
    <div>{{ 'INBOX.CHAT_HISTORY' | translate }}</div>
    <div>
      <button
        mat-flat-button
        color="primary"
        (click)="createConversation()"
        [disabled]="isCreatingConversation()"
        class="new-chat-button"
      >
        <mat-icon [style.visibility]="isCreatingConversation() ? 'hidden' : 'visible'">add</mat-icon>
        <glxy-loading-spinner
          [size]="'small'"
          [style.display]="isCreatingConversation() ? 'block' : 'none'"
          class="loading-spinner"
        ></glxy-loading-spinner>
        <span [style.visibility]="isCreatingConversation() ? 'hidden' : 'visible'">
          {{ 'INBOX.NEW_CHAT' | translate }}
        </span>
      </button>
    </div>
  </div>
  @for (group of groupedConversations$ | async; track group.label) {
    <div class="group-title">{{ group.label | translate }}</div>
    @for (conversationDetail of group.cs; track trackConversationDetailsById(conversationDetail)) {
      <div class="conversation">
        @if (conversationDetail) {
          <a
            [class.active-conversation]="isConversationActive(conversationDetail?.conversation?.conversationId)"
            (click)="conversationSelected(conversationDetail?.conversation?.conversationId)"
            data-action="clicked-conversation"
          >
            <div
              [ngClass]="{ 'unread-font-weight': (conversationDetail.conversation | conversationUnseen | async) }"
              class="conversation-detail-container"
            >
              <div class="conversation-indicator-selected"></div>
              <inbox-conversation-preview [conversationDetail]="conversationDetail"></inbox-conversation-preview>
            </div>
          </a>
        }
      </div>
    }
  }
  <glxy-infinite-scroll-trigger (isVisible)="loadMoreConversations()" />
  @if ((loadingConversations$ | async) === true) {
    <glxy-loading-spinner />
  }
</div>

<inbox-views-empty *ngIf="showInboxZero$ | async"></inbox-views-empty>
